// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import InstructionsPage from './components/InstructionsPage';
import CameraPermissionPage from './components/CameraPermissionPage';
import QuizPage from './components/QuizPage';
import ResultsPage from './components/ResultsPage';
import { QuizProvider } from './context/QuizContext';
import './App.css';

function App() {
  return (
    <QuizProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/instructions" element={<InstructionsPage />} />
            <Route path="/camera" element={<CameraPermissionPage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="/results" element={<ResultsPage />} />
          </Routes>
        </div>
      </Router>
    </QuizProvider>
  );
}

export default App;